
import Header from "../../header";
import Footer from "../../footer";
import ContactForm from "../../contactcomponents/contactform";
import BannerFooter from "./bannerForFooter";
import webimage  from '../../../images/cardpageimages/technicalcourse/fullstackwebdevelopment.jpg'
function WebDesignAndDevelopment() {

    const features = [
        {
          title: "Responsive Web Design",
          description: "Create visually appealing websites that adapt seamlessly to any device, ensuring a user-friendly experience on desktops, tablets, and mobiles.",
        },
        {
          title: "Custom Development Solutions",
          description: "Tailor-made websites designed to meet your specific business needs, offering unique functionality and branding.",
        },
        {
          title: "E-commerce Integration",
          description: "Build powerful online stores with secure payment gateways, product catalogs, and inventory management.",
        },
        {
          title: "SEO Optimization",
          description: "Enhance visibility on search engines with optimized content, meta tags, and performance-focused design.",
        },
        {
          title: "Content Management Systems (CMS)",
          description: "Empower yourself to manage and update your website effortlessly with CMS solutions like WordPress and Shopify.",
        },
        {
          title: "UI/UX Design",
          description: "Engage your audience with intuitive interfaces and user-centric designs that boost conversions.",
        },
        {
          title: "Website Maintenance & Support",
          description: "Ensure your website runs smoothly with regular updates, backups, and 24/7 technical support.",
        },
        {
          title: "Speed Optimization",
          description: "Minimize load times with advanced coding practices and optimized server configurations.",
        },
        {
          title: "API Integration",
          description: "Seamlessly integrate third-party services like payment processors, social media platforms, and analytics tools.",
        },
        {
          title: "Web Accessibility",
          description: "Ensure your website is accessible to everyone, including users with disabilities, adhering to WCAG standards.",
        },
      ];

    return (<>
        <Header />

        <BannerFooter
            title="Web Design And Development"
            text="Website design and development combine creativity and functionality to craft visually appealing, user-friendly websites. Focusing on responsive layouts, seamless navigation, and fast performance, these services ensure exceptional user experiences. Leveraging modern technologies and frameworks, they deliver custom solutions aligned with client goals. From corporate websites to e-commerce portals, effective web design enhances digital presence and business growth."
            imageone={webimage}
            imagetwo={webimage}
        />
         <div className="container my-4">
      <h2 className="text-center mb-4">Website Design & Development</h2>
      <div className="accordion" id="accordionExample">
        {features.map((feature, index) => (
          <div className="accordion-item" key={index}>
            <h2 className="accordion-header" id={`heading${index}`}>
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse${index}`}
                aria-expanded="false"
                aria-controls={`collapse${index}`}
              >
                {feature.title}
              </button>
            </h2>
            <div
              id={`collapse${index}`}
              className="accordion-collapse collapse"
              aria-labelledby={`heading${index}`}
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                {feature.description}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
        <ContactForm/>


        <Footer />
    </>)
}

export default WebDesignAndDevelopment